import { Box, styled } from "@mui/material";
import React from "react";

import { Footer } from "../Footer";
import { SkipLink } from "../SkipLink";

const StyledBackground = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: ${(props) => props.theme.palette.primary.main};
`;

interface Props {
  children: React.ReactNode;
}

export const AuthLayout = ({ children }: Props) => {
  return (
    <StyledBackground>
      <SkipLink />
      {children}
      <Footer inverted />
    </StyledBackground>
  );
};
